import apiClient from '@/lib/api-client';
import { ApiError } from '@/model/ApiError';
import { Module, Mutation, VuexModule, Action } from 'vuex-module-decorators';
import {
    createSignupRequestFromFormData,
    SignupFormData,
    SignupRequest,
} from '@/model/Signup';
import store from '@/store';
import { LoginFormData } from '@/model/Authentication';

@Module({ namespaced: true, preserveState: false })
export default class SignupStorage extends VuexModule {
    error: ApiError | null = null;

    @Mutation
    setError(error: ApiError | null): void {
        this.error = error;
    }

    @Action
    signup(formData: SignupFormData): Promise<void> {
        return apiClient
            .post<SignupRequest, void>(
                '/auth/signup',
                createSignupRequestFromFormData(formData),
            )
            .then(async () => {
                return store
                    .dispatch('authenticationStorage/login', {
                        email: formData.email,
                        password: formData.password,
                    } as LoginFormData)
                    .then(() => {
                        this.context.commit('setError', null);
                        return Promise.resolve();
                    })
                    .catch((error) => {
                        this.context.commit('setError', error);
                        return Promise.reject();
                    });
            })
            .catch((error) => {
                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    get getError(): ApiError | null {
        return this.error;
    }
}
